// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22f2F","comment":"styles_comment__2IvTm"};